import { createOpenFormModalAction } from "@multiweb/reactCore/bridge";
import { IAttrValue } from "@multiweb/types/contracts";

/** Funkce slouží pro složení názvu třídy pro editační komponenty. Možno smazat, až budou vytvořený reactí ekvivalenty obecných komponent Edit, ChceckBox, Select, Memo,... */
export const getEditableControlClassName = (required: boolean, disabled: boolean, aditionalClassName?: string) => {
    let editableControlClassName = "EditableControl";

    if (aditionalClassName)
        editableControlClassName += ` ${aditionalClassName}`;

    if (required)
        editableControlClassName += " Required";

    if (disabled)
        editableControlClassName += " Disabled";

    return editableControlClassName;
};

/**
 * Vytvoří obslužnou funkci kliknutí na button u komponenty TextLOVEdit, která se stará o zobrazení/skrytí editačních dialogů editoru WF.
 * @param toggleEditDialogsVisibility Dispatchnutá akce pro zobrazování/skrytí editačních dialogů.
 * @param openFormModal Vyšle akci pro otevření modálního formuláře.
 * @param onFormClose Callback volaný při zavření modálního formuláře.
 * @param formName Název formuláře k otevření.
 * @param attributeNames Názvy atributů ke čtení.
 * @param condition Podmnka pro zobrazení záznamů.
 */
export const createOnTextLOVEditClick = (
    toggleEditDialogsVisibility: () => void,
    openFormModal: typeof createOpenFormModalAction,
    onFormClose: (results: readonly IAttrValue[] | undefined) => void,
    formName: string,
    attributeNames: readonly string[],
    condition?: string,
) =>
    () => {
        toggleEditDialogsVisibility();
        openFormModal({
            formName,
            attributeNames,
            onClose: (results) => {
                onFormClose(results);
                toggleEditDialogsVisibility();
            },
            condition,
            viewMode: false,
            inLOVMode: true,
            enableLOVSelect: true,
        });
    };
